import { handlePostAction } from "../../../utils/event-api-invoke";
import { getGrossBranchAPIPostSchema, getGrossBranchAPIDeleteSchema, getGrossBranchAuditInfoSchema } from "../create/Schema";

let _isError = false;

const _getPreviousState = (data) => {
  try {
    let _prevState = {};

    _prevState.ServiceType = data?.ServiceType?.label || "";
    _prevState.SectorName = data?.Sector?.label || "";
    _prevState.BranchName = data?.Branch?.label || "";
    _prevState.ContractsGrossMargin = data?.ContractsGrossMargin || 0;
    _prevState.JobsGrossMargin = data?.JobsGrossMargin || 0;
    _prevState.CoefficientWarranty = data?.CoefficientWarranty || 0;

    return JSON.stringify(_prevState);
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const _getCurrentState = (data) => {
  try {
    let _currentState = {};

    _currentState.ServiceType = data?.ServiceType?.label || "";
    _currentState.SectorName = data?.Sector?.label || "";
    _currentState.BranchName = data?.Branch?.label || "";
    _currentState.ContractsGrossMargin = data?.ContractsGrossMargin || 0;
    _currentState.JobsGrossMargin = data?.JobsGrossMargin || 0;
    _currentState.CoefficientWarranty = data?.CoefficientWarranty || 0;
    
    return JSON.stringify(_currentState);
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getAuditInfo = (data, auditConfig) => {
  try {
    let _auditSchema = getGrossBranchAuditInfoSchema();
    let _isDeleted = data?.Deleted;

    _auditSchema.auditInfo[0].shortDesc = data?.ServiceType?.label + " - "+ data?.Sector?.label+ " - "+ data?.Branch?.label;
    _auditSchema.auditInfo[0].currentState = (_isDeleted) ? "{}" : _getCurrentState(data); //If the record is deleted, previousState will be available. The currentState will be available for creation.
    if (auditConfig.editGrossBranchId) {
      _auditSchema.auditInfo[0].LocationKey = auditConfig.editGrossBranchId;
      _auditSchema.auditInfo[0].Action = _isDeleted ? "DELETE" : "EDIT";
      _auditSchema.auditInfo[0].previousState = _isDeleted ? _getPreviousState(data) : _getPreviousState(auditConfig.formdata); //For single tables during record deletion send data to previous state instead of form data
    } else {
      _auditSchema.auditInfo[0].Action = "CREATE";
    }

    return _auditSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getPostPayload = (data, config) => {
  try {

    let _isDeleted = data?.Deleted;
    let _postSchema = {};
    if (_isDeleted) {
      _postSchema = getGrossBranchAPIDeleteSchema(config.countryCode, config.businessCode);

      _postSchema.grossBranch[0].GrossBranchId = config.editGrossBranchId;
      _postSchema.grossBranch[0].Deleted = _isDeleted;

    } else {
      _postSchema = getGrossBranchAPIPostSchema(config.countryCode, config.businessCode);

      _postSchema.grossBranch[0].TypeId = data?.ServiceType?.id || "";
      _postSchema.grossBranch[0].SectorId = data?.Sector?.id || "";
      _postSchema.grossBranch[0].BranchId = data?.Branch?.id || "";
      _postSchema.grossBranch[0].ContractsGrossMargin = data?.ContractsGrossMargin || 0;
      _postSchema.grossBranch[0].JobsGrossMargin = data?.JobsGrossMargin || 0;
      _postSchema.grossBranch[0].CoefficientWarranty = data?.CoefficientWarranty || 0;

      if (config.editGrossBranchId) {
        _postSchema.grossBranch[0].GrossBranchId = config.editGrossBranchId;
      }
    }

    return _postSchema;

  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const saveGrossBranch = async (data, uihandler) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  const {
    EditGrossBranchId: editGrossBranchId,
    settingsConfig: { businessCode, countryCode },
    formdata
  } = uihandler;
  try {
    let _auditInfo = getAuditInfo(data, { editGrossBranchId, formdata });
    let _postPayload = getPostPayload(data, { editGrossBranchId, businessCode, countryCode });

    let _postRequest = { ..._postPayload, ..._auditInfo };

    let res = await handlePostAction(_postRequest, "grossBranch");
    if (res && res.status && res.status === 200) {
      if (res.data.errorNumber > 0) {
        _isError = true;
        status.errorMessage = res.data.errorDescription;
      } else {
        status.responseStatus = res.status;
      }
    }

  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

export { saveGrossBranch};
